import { projectFunctions } from "../contexts/IDEContext.js";
export const SX_FORMAT = (funcs=[]) => {
  let allFuncNames = funcs
  projectFunctions?.map((f) => allFuncNames.push(f?.name))
  const functionNames = allFuncNames.join("|") || "";
  // Only add the dynamic pattern if we actually have function names
  const dynamicMacroPattern = functionNames?.length > 0
    ? [new RegExp(`(${functionNames})(?=\\s|\\/\\/|\\/\\*|$)`), "macros"]
    : null;
  return {
    defaultToken: "invalid",
    tokenPostfix: [".sx",".sxLib"],
    ignoreCase: true,
    keywords: ["import", "repeat", "end", "|", "break", "pushCodeData", "pushCodeDataV"],
    symbols: /\|/,
    escapes:
      /\\(?:[abfnrtv\\"']|x[0-9A-Fa-f]{1,4}|u[0-9A-Fa-f]{4}|U[0-9A-Fa-f]{8})/,
    comments: { lineComment: "//", blockComment: ["/*", "*/"] },
    autoClosingPairs: [
      { open: "'", close: "'", notIn: ["string", "comment"] },
      { open: '"', close: '"', notIn: ["string", "comment"] },
      { open: "`", close: "`", notIn: ["string", "comment"] },
      { open: "#", close: " end", notIn: ["string", "comment"] },
      { open: "/*", close: "*/", notIn: ["string"] },
    ],
    tokenizer: {
      root: [
        [/(?:OP_)?(1negate|false|true)(?=\s|\/\/|\/\*|$)/i, "number.float"],
        [
          /(?:OP_)?(1add|1sub|2mul|2div|negate|abs|not|0notEqual|add|sub|mul|div|mod|lshift|rshift|boolAnd|boolOr|numEqualVerify|numEqual|numNotEqual|lessThanOrEqual|greaterThanOrEqual|lessThan|greaterThan|min|max|within)(?=\s|\/\/|\/\*|$)/i,
          "op-math",
        ],
        [/[-]?[0-9]+n(?=\s|\/\/|\/\*|$)/, "number"],
        [/((0x)?[a-fA-F0-9]{2})+(?=\s|\/\/|\/\*|$)/, "number.hex"],
[/(^|\b)#[a-zA-Z_0-9]*(?=\s|\/\/|\/\*|$)/, "macros"],
        ...(dynamicMacroPattern ? [dynamicMacroPattern] : []), 
        [
          /(?:OP_)?(toAltStack|fromAltStack|ifDup|depth|drop|dup|nip|over|pick|roll|rot|swap|tuck|2drop|2dup|3dup|2over|2rot|2swap)(?=\s|\/\/|\/\*|$)/i,
          "op-stack",
        ],
        [
          /(?:OP_)?(nop2|checkLockTimeVerify|nop3|checkSequenceVerify|nop4|nop5|nop6|nop7|nop8|nop9|nop10|nop1|nop|verify|verIf|verNotif|ver|if|notif|else|endIf|return)(?=\s|\/\/|\/\*|$)/i,
          "op-control",
        ],
        [
          /(0|OP_10|OP_11|OP_12|OP_13|OP_14|OP_15|OP_16|OP_0|OP_1|OP_2|OP_3|OP_4|OP_5|OP_6|OP_7|OP_8|OP_9)(?=\s|\/\/|\/\*|$)/i,
          "number.float",
        ],
        //[/(?:OP_)?(reserved1|reserved2|reserved|pushData1|pushData2|pushData4|smallData|smallInteger|pubKeys|pubKeyHash|pubKey|invalidOpCode)(?=\s|\/\/|\/\*|$)/i, "op-pushdata"],
        [
          /(?:OP_)?(ripemd160|sha1|sha256|hash160|hash256|codeSeparator|checkSigVerify|checkSig|checkMultiSigVerify|checkMultiSig)(?=\s|\/\/|\/\*|$)/i,
          "op-crypto",
        ],
        [
          /(?:OP_)?(invert|and|or|xor|equalVerify|equal|cat|split|bin2num|num2bin|size)(?=\s|\/\/|\/\*|$)/i,
          "op-bin",
        ],
        { include: "whitespace" }, // Add this
        { include: "common" },
      ],
      common: [
        { include: "whitespace" }, // Add this
        [
          /[a-z_$][\w$]*/,
          {
            cases: {
              "@keywords": "keyword",
              "@default": "",
            },
          },
        ],
        [/\.[a-zA-Z_0-9]+\??/, "type.identifier"], // variables
        [/\d+/, "number"],
        [
          /@symbols/,
          {
            cases: {
              "@default": "",
            },
          },
        ],
        // strings
        [/"([^"\\]|\\.)*$/, "string.invalid"], // non-teminated string
        [/'([^'\\]|\\.)*$/, "string.invalid"], // non-teminated string
        [/"/, "string", "@string_double"],
        [/'/, "string", "@string_single"],
        [/`/, "string", "@string_backtick"],
        [/@(label|test|l|t|desc|d|requires|cs):(?=.*?(?=\s|$))/, "notes"],
      ],

      string_follow_label: [
        // Exclude matches that start with '0x'
        // This regex matches any sequence of characters that does not start with '0x'
        // and continues until a whitespace or the end of the line.
        [/(?!0x)[^ \t\r\n]+(?=\s|\/\/|\/\*|$)/, "string", "@pop"],
      ],
      whitespace: [
        [/[ \t\r\n]+/, ""],
        [/\/\*/, "comment", "@comment"],
        [/\/\/.*$/, "comment"],
      ],
      comment: [
        [/[^\/*]+/, "comment"],
        [/\/\*/, "comment", "@comment"],
        [/\*\//, "comment", "@pop"],
        [/[\/*]/, "comment"],
      ],
      string_double: [
        [/[^\\"]+/, "string"],
        [/@escapes/, "string.escape"],
        [/\\./, "string.escape.invalid"],
        [/"/, "string", "@pop"],
      ],
      string_single: [
        [/[^\\']+/, "string"],
        [/@escapes/, "string.escape"],
        [/\\./, "string.escape.invalid"],
        [/'/, "string", "@pop"],
      ],
      string_backtick: [
        [/\$\{/, { token: "delimiter.bracket", next: "@bracketCounting" }],
        [/[^\\`$]+/, "string"],
        [/@escapes/, "string.escape"],
        [/\\./, "string.escape.invalid"],
        [/`/, "string", "@pop"],
      ],
      bracketCounting: [
        [/\{/, "delimiter.bracket", "@bracketCounting"],
        [/\}/, "delimiter.bracket", "@pop"],
        { include: "common" },
      ],
    },
  };
};
